module.exports = __webpack_public_path__ + "img/toxic.51d3b196.svg";